import { CommandGroup, CommandItem } from '@/components/ui/command';
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid';
import type { ModelName } from '@pigello/pigello-matrix';
import type { Dispatch, SetStateAction } from 'react';
import type { Page } from '..';
import { useGetRoutes } from '../hooks/use-get-routes';

export function SearchableModelsGroup({
  setPages,
  setSearch,
  setModelName,
}: {
  setSearch: Dispatch<SetStateAction<string>>;
  setPages: Dispatch<SetStateAction<Page[]>>;
  setModelName: Dispatch<SetStateAction<ModelName | undefined>>;
}) {
  const searchableModels = useGetRoutes(true);
  return (
    <CommandGroup heading='Välj modell'>
      {searchableModels.map((route) => (
        <CommandItem
          key={`${route.modelName}-${route.title}`}
          onSelect={() => {
            setModelName(route.modelName);
            setPages((pages) => [...pages, 'search']);
            setSearch('');
          }}
        >
          <MagnifyingGlassIcon className='mr-2 size-4' />
          <span>
            Sök på{' '}
            <span className='first-letter:capitalize'>
              {route.title.toLowerCase()}
            </span>
          </span>
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
